<div class="expander">
  <button class="expander-header" (click)="toggle()">
    <span class="chevron" [class.open]="open">▶</span> Settings
  </button>
  <div class="expander-body" *ngIf="open"></div>
</div>